import {withTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {selectFeatureFlag} from 'App/features/featureFlags/featureFlagsSlice';
import {selectUserCredentials} from 'App/features/user/userSlice';
import ProfileAvatar from 'Components/profile_avatar';

import AuthenticatedMenu from './authenticated_menu';

function Controls() {
  const {organization} = useSelector(selectUserCredentials) || {};
  const isRedesignAvailable = useSelector(
    selectFeatureFlag('isRedesignAvailable'),
  );

  if (!organization) {
    return null;
  }

  const profile = {
    name: organization.name,
    image: organization.image,
    hash: organization.hash,
  };

  return (
    <div className="m-3 flex">
      <div className="flex h-[40px] items-center gap-x-4 rounded-[8px] pl-[4px] text-[0.9rem] text-gray-700">
        <ProfileAvatar profile={profile} width={30} height={30} />
        {!isRedesignAvailable && (
          <div className="border-x px-[8px] text-white">{profile.name}</div>
        )}
        <AuthenticatedMenu />
      </div>
    </div>
  );
}

// Added HOC to rerender Controls, when language is change. Maybe find smth better?
export default withTranslation()(Controls);
